"use client";
import { useEffect, useState } from "react";
import styled from "styled-components";
import Title from "@/components/Title";
import { Black } from "@/styles/globalStyleVars";
import { Col, Container, Form, Row } from "react-bootstrap";
import Button from "@/components/Button";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { redirect, usePathname, useRouter } from "next/navigation";
import Link from "next/link";
import axios from "axios";
import Cookies from "js-cookie";
import { Loading } from "@/components/Loading";

const MyComponent = () => {
  const location = usePathname();
  const [isSubmitting, setIsSubmitting] = useState(true);
  const router = useRouter();

  useEffect(() => {
    setTimeout(() => {
      setIsSubmitting(false);
    }, 300);
  }, []);

  const { register, handleSubmit, formState, reset } = useForm({ mode: "all" });
  const { errors, isSubmitSuccessful } = formState;

  //--- form submit

  const success = (msg) =>
    toast.success(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const error = (msg) =>
    toast.error(msg, {
      position: "top-right",
      autoClose: 4000,
      closeOnClick: true,
      progress: undefined,
    });

  const onSubmit = async (data) => {
    setIsSubmitting(true); // Show spinner

    try {
      const formData = new FormData();
      formData.append("email", data?.email);
      formData.append("password", data?.password);

      const response = await axios.post(
        "https://cms.ucbstock.com.bd//wp-json/custom/v1/login",
        formData
      );

      if (response.status === 200) {
        Cookies.set("user-token", response?.data?.token?.token, { expires: 7 });
        Cookies.set("user-token-auth", response?.data?.user_id, { expires: 7 });
        success("Login successfully");
        reset(); // Reset form fields
        setTimeout(() => {
          window.location.href = "/research";
        }, 500)

      }
    } catch (err) {
      if (err.response?.status === 200) {
      } else {
        error(
          err?.response?.data?.message
            ? err?.response?.data?.message
            : "Failed to submit form. Please try again later."
        );
      }
    } finally {
      setIsSubmitting(false); // Hide spinner
    }
  };

  const onError = (errors) => {
    // setToastShown(false); // Reset toast shown state on new submission attempt
    const firstError = Object.values(errors)[0];
    error(firstError.message);
  };

  return (
    <StyledComponent className={"user pt-200 pb-200"}>
      {isSubmitting && <Loading />}
      <Container>
        <Row>
          <Col sm={12}>
            <Title
              margin={"0 0 60px 0"}
              color={"#191919"}
              text={"User Log In"}
              number={"I"}
            />
          </Col>

          <Col md={6} sm={12}>
            <Form onSubmit={handleSubmit(onSubmit, onError)}>
              <Form.Group className={"from-group"}>
                <Form.Control
                  {...register("email", {
                    required: {
                      value: true,
                      message: "Enter a valid email address",
                    },
                    pattern: {
                      value:
                        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                      message: "Enter a valid email address",
                    },
                  })}
                  type="email*"
                  placeholder="Email*"
                />
                {errors.email && (
                  <span className="error-message form-error">
                    {errors.email.message}
                  </span>
                )}
              </Form.Group>
              <Form.Group className={"from-group"}>
                <Form.Control
                  {...register("password", {
                    required: {
                      value: true,
                      message: "Enter password",
                    },
                  })}
                  type="password"
                  placeholder="Password*"
                />
                {errors.password && (
                  <span className={"form-error error-message"}>
                    {errors.password?.message}
                  </span>
                )}
              </Form.Group>

              <div className={`form-group width-fit`}>
                <div onClick={handleSubmit(onSubmit, onError)}>
                  <Button
                    src={"javascript:void(0)"}
                    margin={"60px 0 0 0"}
                    text={"Log In"}
                  />
                </div>
              </div>
            </Form>

            <div className="user-alter">
              <p>
                New User? <Link  prefetch={true} href={"/research/sign-up"}> Sign Up</Link>
              </p>
              <p>
                Forgot your password?{" "}
                <Link  prefetch={true} href={"/research/forget-password"}>
                  {" "}
                  Recover your account{" "}
                </Link>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </StyledComponent>
  );
};

const StyledComponent = styled.section`
  background-color: #f4f4f4;

  .from-group {
    position: relative;

    .form-error {
      position: absolute;
      font-size: 10px;
      color: #ec1c23 !important;
      top: 100%;
    }

    margin-bottom: 25px;

    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }

  .form-control {
    background-color: transparent;
    border: none;
    border-bottom: 1px solid #191919;
    padding-left: 0;
    height: 45px;
    //margin-bottom: 25px;
    color: #191919;

    &:focus {
      border: none;
      border-bottom: 1px solid #191919 !important;
      border-color: #191919;
      outline: none;
      box-shadow: none;
    }

    &:focus-within {
      border: none;
      border-bottom: 1px solid #191919 !important;
      outline: none;
      border-color: #191919;

      box-shadow: none;
    }

    &::placeholder {
      font-size: 15px;
      color: #191919;
    }
  }

  input:-webkit-autofill {
    -webkit-text-fill-color: ${Black} !important;
    border-bottom: 1px solid #26201e;

    &:hover {
      border-bottom: 1px solid #26201e !important;
    }

    &:focus {
      border-bottom: 1px solid #26201e !important;
    }
  }

  .user-alter {
    margin-top: 60px;

    p {
      color: #08082b;

      &:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }

    a {
      color: #ec1c24;
      text-decoration: underline;

      &:hover {
        color: #08082b !important;
      }
    }
  }
`;

export default MyComponent;
